export const siteName = "大师兄影视";

export const navItems = [
  { label: "概览", href: "#overview" },
  { label: "大师兄电影", href: "#films" },
  { label: "甄子丹", href: "#actor" },
  { label: "类型对照", href: "#genres" },
  { label: "同门看点", href: "#features" },
  { label: "观影指南", href: "#guide" },
  { label: "标签索引", href: "#tags" },
];

export const heroCards = [
  {
    icon: "ri-community-line",
    title: "师兄系列",
    desc: "从师门关系这条主线出发，梳理由此展开的叙事线索。",
    href: "#overview",
  },
  {
    icon: "ri-movie-2-line",
    title: "大师兄电影",
    desc: "按题材方向整理核心角色与常见的故事类型。",
    href: "#films",
  },
  {
    icon: "ri-user-star-line",
    title: "甄子丹",
    desc: "聚焦以功夫动作见长的表演方式与人物塑造。",
    href: "#actor",
  },
  {
    icon: "ri-layout-grid-line",
    title: "类型对照",
    desc: "喜剧片与剧情片，两种观看方向的差异与取舍。",
    href: "#genres",
  },
];

export const heroStats = [
  { value: "6", label: "题材方向" },
  { value: "5", label: "代表看点" },
  { value: "2", label: "类型对照" },
  { value: "6", label: "观影问答" },
];

export const overviewPoints = [
  {
    icon: "ri-links-line",
    title: "同门关系为线",
    desc: "以师门、同门之间的关系作为叙事主线，情义往往比招式更先立住人物。",
  },
  {
    icon: "ri-shield-star-line",
    title: "大师兄为核心",
    desc: "大师兄通常承担带领与兜底的位置，既是行动者，也是情绪的支点。",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "题材跨度大",
    desc: "同一师门设定可以放进动作、喜剧与剧情等不同框架里展开，气质各不相同。",
  },
  {
    icon: "ri-list-check-2",
    title: "按方向查阅",
    desc: "本站把零散信息按人物、题材与类型分门别类，方便逐项对照核对。",
  },
];

export const filmFilters = ["全部", "动作", "喜剧", "剧情"];

export const filmTopics = [
  {
    id: "action-craft",
    title: "功夫动作",
    category: "动作",
    tag: "动作设计",
    desc: "以身体动作推动情节，招式节奏本身就是叙事语言，强调力量、距离与反应。",
    points: ["关注动作设计的连贯性与镜头调度", "招式风格常被用来暗示人物性格"],
    image:
      "https://readdy.ai/api/search-image?query=dynamic%20motion%20of%20martial%20arts%20training%20with%20wooden%20practice%20dummy%2C%20warm%20amber%20light%20rays%20through%20floating%20dust%2C%20cinematic%20stylized%20composition%2C%20no%20faces%2C%20editorial%20photography&width=800&height=600&seq=master-film-action-01&orientation=landscape",
  },
  {
    id: "brotherhood",
    title: "师门情义",
    category: "剧情",
    tag: "关系主线",
    desc: "把重心放在同门之间的信任与担当上，冲突多来自选择，而不是单纯的对打。",
    points: ["关系变化往往比胜负更关键", "对话与沉默共同塑造情感张力"],
    image:
      "https://readdy.ai/api/search-image?query=stylized%20silhouette%20of%20two%20standing%20figures%20on%20a%20misty%20hilltop%20at%20warm%20sunset%2C%20brotherhood%20and%20trust%20theme%2C%20cinematic%20warm%20orange%20tones%2C%20minimal%20artistic%20composition%2C%20no%20faces&width=800&height=600&seq=master-film-brother-02&orientation=landscape",
  },
  {
    id: "street-comedy",
    title: "市井喜剧",
    category: "喜剧",
    tag: "轻松节奏",
    desc: "借日常场景与人物反差制造笑点，节奏轻快，适合放松式的观看状态。",
    points: ["笑点常来自性格与处境的错位", "轻喜剧外壳下也可能藏着温情"],
    image:
      "https://readdy.ai/api/search-image?query=warm%20festive%20town%20street%20with%20hanging%20lanterns%20and%20market%20stalls%20at%20golden%20hour%2C%20cheerful%20cozy%20atmosphere%2C%20cinematic%20stylized%20art%2C%20no%20faces%2C%20rich%20amber%20and%20red%20tones&width=800&height=600&seq=master-film-comedy-03&orientation=landscape",
  },
  {
    id: "character-arc",
    title: "人物弧光",
    category: "剧情",
    tag: "人物成长",
    desc: "围绕一个核心角色的转变展开，从立场的松动，到选择最终的确立。",
    points: ["留意角色动机的层层递进", "配角往往承担推动变化的功能"],
    image:
      "https://readdy.ai/api/search-image?query=quiet%20cinematic%20interior%20with%20a%20single%20wooden%20chair%20beside%20a%20window%2C%20warm%20afternoon%20light%20and%20long%20shadows%2C%20melancholic%20storytelling%20mood%2C%20stylized%20art%2C%20no%20people&width=800&height=600&seq=master-film-drama-04&orientation=landscape",
  },
  {
    id: "ensemble",
    title: "群像节奏",
    category: "喜剧",
    tag: "群戏调度",
    desc: "多人同框的调度考验节奏，群像之间互相接梗，单位时间里的信息密度更高。",
    points: ["对话来回的节奏决定喜剧效果", "群像关系网让故事更有生活感"],
    image:
      "https://readdy.ai/api/search-image?query=stylized%20silhouette%20group%20of%20travelers%20walking%20along%20a%20ridge%20at%20dusk%2C%20warm%20golden%20haze%2C%20cinematic%20epic%20ensemble%20composition%2C%20faces%20not%20visible%2C%20artistic%20warm%20tones&width=800&height=600&seq=master-film-group-05&orientation=landscape",
  },
  {
    id: "duel",
    title: "热血对决",
    category: "动作",
    tag: "高潮段落",
    desc: "把情绪推到顶点的一场戏，胜负之外，更强调立场与信念之间的碰撞。",
    points: ["高潮段落的镜头与配乐相互配合", "对决结果常被用来收束人物关系"],
    image:
      "https://readdy.ai/api/search-image?query=dramatic%20cinematic%20stage%20lit%20by%20a%20single%20spotlight%20with%20rising%20dust%2C%20tension%20and%20energy%20in%20the%20air%2C%20deep%20red%20and%20amber%20tones%2C%20stylized%20artistic%20composition%2C%20no%20people%2C%20no%20faces&width=800&height=600&seq=master-film-duel-06&orientation=landscape",
  },
];

export const actorPoints = [
  {
    icon: "ri-boxing-line",
    title: "动作底子扎实",
    desc: "以功夫动作见长，动作完成度高，招式之间的衔接干净利落。",
  },
  {
    icon: "ri-focus-3-line",
    title: "把性格写进招式",
    desc: "同一套动作里也能看出角色的脾气，打斗本身在替人物说话。",
  },
  {
    icon: "ri-swap-box-line",
    title: "类型跨度不小",
    desc: "既能撑起硬派动作，也能接住轻喜剧的节奏，戏路并不单一。",
  },
  {
    icon: "ri-eye-line",
    title: "细节才是重点",
    desc: "留意身法、眼神与停顿，这些地方最能看出角色的真实状态。",
  },
];

export const genres = [
  {
    key: "comedy",
    name: "喜剧片",
    icon: "ri-emotion-laugh-line",
    summary: "适合轻松观看的一条方向",
    focus: "以轻松节奏和人物反差为主，冲突更多停留在生活层面，观感更松弛。",
    rhythm: "段落短、转折快，笑点相对密集，适合用碎片时间分段观看。",
    audience: "想放松、不想被沉重情节长时间牵住注意力的观众。",
    tips: [
      "留意反复出现的口头禅与习惯动作",
      "群戏段落信息量大，可以放慢节奏看",
      "笑点背后通常还牵着一条温情线",
    ],
    image:
      "https://readdy.ai/api/search-image?query=warm%20cheerful%20alley%20with%20glowing%20lanterns%20and%20cozy%20shops%20at%20evening%2C%20playful%20and%20friendly%20mood%2C%20cinematic%20stylized%20art%2C%20golden%20amber%20tones%2C%20no%20faces%2C%20no%20people%20in%20focus&width=900&height=700&seq=master-genre-comedy-11&orientation=landscape",
  },
  {
    key: "drama",
    name: "剧情片",
    icon: "ri-film-line",
    summary: "适合沉浸跟随的一条方向",
    focus: "以人物关系与情感变化为主，动作与喜剧退到次要位置，重心在内心。",
    rhythm: "节奏偏慢、留白更多，需要一点耐心去跟随人物的情绪走向。",
    audience: "喜欢琢磨人物动机、享受沉浸式故事的观众。",
    tips: [
      "关注角色的沉默与停顿",
      "留意前后呼应的那些小道具",
      "配角的选择往往在暗示主题",
    ],
    image:
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20window%20light%20across%20an%20empty%20traditional%20room%2C%20deep%20warm%20shadows%20and%20soft%20dust%2C%20contemplative%20drama%20mood%2C%20stylized%20art%2C%20no%20people%2C%20rich%20brown%20tones&width=900&height=700&seq=master-genre-drama-12&orientation=landscape",
  },
];

export const featureItems = [
  {
    no: "01",
    title: "关系层次",
    desc: "师徒、同门与对手三种关系相互叠加，构成本类作品最主要的张力来源。",
  },
  {
    no: "02",
    title: "动作性格",
    desc: "不同人物的招式风格各异，动作设计本身就在提前交代各自的性格。",
  },
  {
    no: "03",
    title: "节奏平衡",
    desc: "正剧段落与轻松段落交替出现，避免长时间停留在同一种情绪里。",
  },
  {
    no: "04",
    title: "配角功能",
    desc: "配角常常负责点题或推动转折，看的时候不妨多留意他们的选择。",
  },
  {
    no: "05",
    title: "观看顺序",
    desc: "可以按人物线索，也可以按题材方向两条路径切入，各取所需即可。",
  },
];

export const faqs = [
  {
    q: "大师兄影视主要收录哪类内容？",
    a: "围绕师兄系列、同门电影与大师兄电影等方向，整理人物、题材与类型相关的基本信息，方便对照查阅。",
  },
  {
    q: "师兄系列和同门电影有什么关系？",
    a: "师兄系列侧重师门关系这条主线，同门电影则泛指以同门人物关系为核心的影片，两者在设定上确有交集。",
  },
  {
    q: "大师兄电影一般有哪些看点？",
    a: "通常是关系张力、动作设计与人物成长三部分相互配合，看点主要集中在人物如何做出选择。",
  },
  {
    q: "喜剧片和剧情片应该怎么选？",
    a: "想看轻松节奏就选喜剧片，想沉浸人物情感就选剧情片；也可以先看剧情片，再用喜剧片放松回来。",
  },
  {
    q: "关于甄子丹的内容要怎么理解？",
    a: "页面中的介绍为一般性概括，用于了解其动作与表演的方向；具体作品信息请以官方资料为准。",
  },
  {
    q: "页面上的筛选和切换会联网吗？",
    a: "不会。筛选与标签切换只作用于本页已经展示的内容，离线浏览同样可以正常使用。",
  },
];

export const tagGroups = [
  {
    title: "人物与系列",
    tags: ["大师兄影视", "师兄系列", "同门电影", "大师兄电影", "甄子丹"],
  },
  {
    title: "题材方向",
    tags: ["功夫动作", "师门情义", "市井喜剧", "人物弧光", "群像节奏", "热血对决"],
  },
  {
    title: "类型与看点",
    tags: ["喜剧片", "剧情片", "关系张力", "动作设计", "人物成长", "观看顺序"],
  },
];